(function($){

	var pathogenesis = function(){
		var self = this;


		var s = {
			pathogenesis: $('#pathogenesis'),
			loginForm: $('#login-form'),
			username: $('#username'),
			pwd: $('#pwd'),
			ajax: $.ajax(),
			resultTemplate: wp.template('pathogenesis-result')
		};


		self.init = function(){
			self.actionHandler();
			s.pathogenesis.fadeIn('slow');
		};


		self.actionHandler = function(){
			s.loginForm.on('submit', self.loginUser);
			s.pathogenesis.on('keyup', '#search', self.makeSearch );
			s.pathogenesis.on('submit', '#pathogenesis-form', function(e){e.preventDefault();} ); //The form should never be submited
			// s.search.on('keyup', self.makeSearch);
		};


		self.makeSearch = function(){
			var $this = $(this);
			var nonce = s.pathogenesis.find('#gf-nonce').val();
			s.ajax.abort();

			s.ajax = $.ajax({
				url: gf_pat.ajax_url,
				type: 'POST',
				data: {
					action: 'gf-search-pathogenesis',
					nonce: nonce,
					search: $this.val()
				},
				success:function( response ){
					s.pathogenesis.find('#results').empty();
					$('#num-of-results').html(response.length);
					$.each( response.data, function( key, val ){
						if(val.title) {
							s.pathogenesis.find('#results').append( s.resultTemplate( val ) );
						}
					});	
					
				}
			});			
		};





		self.loginUser = function(e){
			e.preventDefault();
			var $this = $(this);
			s.pathogenesis.find('#response-box').empty();	
			s.pathogenesis.find('#response-box').fadeOut('fast');
			// Validate the form, if not valid then break the script
			if ( !self.formValidate($this) ) {
				return;
			}
			$.ajax({
				url: gf_pat.ajax_url,
				type: 'POST',
				data:{
					action: 'gf-login',
					nonce: gf_pat.nonce,
					username: s.username.val(),
					pwd: s.pwd.val()
				},
				success:function( response ){
					if ( response.success && response.data ) {
						location.reload();
						inputs = s.pathogenesis.find('.input-wrapper');

						// input.slideUp('slow',function(){ participant.remove(); });
						
						inputs.animate({
							opacity: 0
					  	}, 1000, function() {

					  		s.pathogenesis.html( response.data ).fadeIn('slow');
					  	});
						
					} else{
						if ( response.data ) {
							s.pathogenesis.find('#response-box').html( response.data );
						} else{
							s.pathogenesis.find('#response-box').html( 'Fel användarnamn och/eller lösenord' );	
						}
						s.pathogenesis.find('#response-box').fadeIn('slow');
					}
				}
			});

		};

		self.formValidate = function(){
			var $this = $(this);
			var is_valid = true;

			$this.find('input[required="required"]').each( function(){
				var $input = $(this);
				var type = $input.attr('type');

				if ( $input.val() === '' ) {
					$input.addClass('invalid');
					is_valid = false;
				}

				if ( 'email' == type ) {
					if ( !self.is_email($input.val()) ) {
						$input.addClass('invalid');
						is_valid = false;
					}
				}


			});

			return is_valid;

		};



		/* HELPER FUNCTIONS */



		/**
		 * Validates an email address
		 * @param  {strong}  email 	String to be tested
		 * @return {Boolean}       
		 */
		self.is_email = function( email ){
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		};

		self.init();
	};


	$(document).ready(function(){
		new pathogenesis();
	});



})(jQuery,window,document,wp);